import { z } from "zod";
import { BaseDrawer, BaseDrawerState, CreateBaseDrawerHook } from "../base_drawer";
import { FormSelectInput } from "../../masked_inputs/react_forms/form_select_input";
import { FormSwitchInput } from "../../masked_inputs/react_forms/form_switch_input";
import { useMemo } from "react";

import DefaultFormInput from "../../default_form_input";

/**
 * Schema
 */

const ProdutoServicoSchema = z.object({
  ativo: z.coerce.boolean().default(true),
  produtoServico: z.string({ required_error: 'Este campo deve ser preenchido!' }).nonempty('Este campo deve ser preenchido!'),
  tipo: z.coerce.number().default(1),
  unidade: z.string().optional(),
  norma: z.string().optional(),
});

type ProdutoServicoForm = z.infer<typeof ProdutoServicoSchema>;

const initializeProdutoServicoForm: Partial<ProdutoServicoForm> = {
  ativo: true,
  tipo: 1,
};

/**
 * useProdutoServicoDrawer
 * [produtoServicoStateDrawer, startProdutoServicoDrawer]
 */

export const useProdutoServicoDrawer = CreateBaseDrawerHook<ProdutoServicoForm>();

/**
 * ProdutoServicoDrawer
 */

type Props = {
  state: BaseDrawerState<ProdutoServicoForm>;
  saving: boolean;
};

export const ProdutoServicoDrawer = ({
  state,
  saving,
}: Props) => {
  const tipoOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Produto',
      },
      {
        id: 2,
        label: 'Serviço',
      }
    ];
  }, [
  ]);

  return (
    <BaseDrawer
      title="Novo Produto/Serviço"
      saving={saving}
      state={state}
      schema={ProdutoServicoSchema}
      defaultValues={initializeProdutoServicoForm}>
      {
        (hookForm) => (
          <>
            <FormSwitchInput
              name='ativo'
              readOnly={saving}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='produtoServico'
              label='Produto/Serviço'
              required={true}
              reactHookForm={hookForm}
            />

            <FormSelectInput
              name='tipo'
              label='Tipo'
              showSelectionLabel={false}
              options={tipoOptions}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='unidade'
              label='Unidade'
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='norma'
              label='Norma'
              reactHookForm={hookForm}
            />
          </>
        )
      }
    </BaseDrawer>
  );
}